import {PHASES, WAR_PHASE_STAGES} from "../../../constants/phases";

/**
 * Одновременный ли сейчас этап — такой, где действуют все игроки разом, а не
 * только текущий: расстановка, этап ближнего боя и (в сетевой партии с
 * isParallelSupply) фаза снабжения.
 *
 * @param phase
 * @param warPhaseStage
 * @param {boolean} [isParallelSupply] - gameState.isParallelSupply: снабжение
 * одновременное только в партиях, где его включил сервер (см.
 * utils/gameState/supply/parallelSupply)
 */
export const checkIfParallelTurn = (phase, warPhaseStage, isParallelSupply = false) => {
  return phase === PHASES.SETUP
    || (phase === PHASES.WAR && warPhaseStage === WAR_PHASE_STAGES.COMBAT)
    || (phase === PHASES.SUPPLY && Boolean(isParallelSupply));
}
